import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { UserModel } from 'app/_models/user-model';
declare const swal: any;

@Injectable({
  providedIn: 'root'
})
export class CanActivateGuard  {
  currentUser: UserModel;
  roles: string[];
  routeAllowedRoles: string[];
  isAuthenticated: boolean = false;

  constructor(
    private readonly router: Router
  ) { }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    // Step 1: Check if user object exists
    this.currentUser = JSON.parse(sessionStorage.getItem('user'));

    if (!this.currentUser) {
      this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
      return false;
    }

    // Step 2: Assume authenticated if user is present (backend validates session via sessionId)
    this.roles = this.currentUser.roles;
    this.isAuthenticated = true;

    // Step 3: Check role-based authorization
    return this.getRoles(route);
  }

  getRoles(route: ActivatedRouteSnapshot): boolean {
    const { roles } = route.data;

    if (roles && roles.length > 0) {
      const roleFound = roles.some(role => this.roles.includes(role));
      if (!roleFound) {
        swal({
          text: 'You are not authorized to view this page!',
          confirmButtonClass: 'btn btn-info',
        });
        return false;
      }
    }

    return true;
  }
}


 
